






























import { Vue, Component } from 'vue-property-decorator'
import { Action, Mutation, Getter } from 'vuex-class'
import { ObjectItem } from '../store/types'

import Header from '@/components/Header.vue'
import Dropdown from '@/components/Dropdown.vue'

@Component({
  components: {
    Header,
    Dropdown
  }
})
export default class ChooseCountry extends Vue {
  @Getter('CONTENT/currentCountryObject') currentCountryObject!: ObjectItem
  @Getter('CONTENT/getCountries') countries!: ObjectItem[]

  @Action('CONTENT/validateCountry') validateCountry!: () => void
  @Mutation('CONTENT/UPDATE_FORCED_COUNTRY') updateCountry!: (value: string | null) => void

  changeCountry (value: ObjectItem) {
    this.updateCountry(value.key)
  }
}
